import { getSegment } from "../services/segmentos";
import { drawSegments } from "../helpers/segmentos";
import { UCL } from "../core/UserClientLibs";
import coockieHelper from "../../common/helpers/cookieHelper";

const evaluateSegments = async () => {
    let maxorg;
    const userDataUCL = await UCL.GetUserInfo();
    const controlGroupV3 = coockieHelper.readCookie("controlGroupV3");
    if (controlGroupV3) {
      const controllGroup = JSON.parse(controlGroupV3);
      maxorg = controllGroup.GrupoControlMeteredV3;
    }

    if (hasUserData(maxorg, userDataUCL?.productos_premium)) {
      const userDataDecoded = btoa(
        JSON.stringify({
          maxorg,
          productosPremuim: userDataUCL?.productos_premium,
        })
      );

      const segmentResult = await getSegment(userDataDecoded);
      //TODO: Pensar refactor para que si corresponde mostrar el wall default mostrar directamente el default
      if (segmentResult) {
        const { Titles, Styles, Combos, Counter } = segmentResult;
        drawSegments(Titles, Styles, Combos, Counter, window.LN.PaywallHub.idWall);
      }
    }
};
export default evaluateSegments;
/**
 *
 * @param {{ maxorg: number, productosPremuim: Array<number> }} userData maxorg y productos premium del usuario.
 * @returns `true` si se le proporcionan datos del usuario, `false` si no los recibe.
 */
const hasUserData = (maxorg, productosPremuim) => {
  const hasProductPremium = productosPremuim?.length > 0;
  return maxorg || hasProductPremium;
};


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/controllers/segmentos.js